// client/src/components/Finances/MonthlyCostBreakdown.js

const LABELS = {
  mortgagePayment: "Mortgage Payment",
  propertyTax: "Property Tax",
  insurance: "Insurance",
  hydro: "Hydro",
  gas: "Gas",
  water: "Water",
  internet: "Internet",
  condoFees: "Condo / HOA Fees",
  maintenanceReserve: "Maintenance Reserve",
};

export default function MonthlyCostBreakdown({ costs }) {
  if (!costs) {
    return (
      <div className="bg-white shadow rounded-xl p-6 text-sm text-gray-500">
        No monthly cost data available.
      </div>
    );
  }

  const safe = (n) => Number(n || 0).toLocaleString();

  // destructure total for the footer
  const { total, ...items } = costs;

  return (
    <div className="bg-white shadow rounded-xl p-6">
      <h2 className="text-lg font-semibold mb-4">Monthly Costs</h2>

      <div className="space-y-3">

        {/* Each cost row */}
        {Object.entries(items).map(([key, value]) => (
          <div
            key={key}
            className="flex justify-between border-b pb-2"
          >
            <p className="capitalize text-sm text-gray-700">
              {LABELS[key] ?? key.replace(/_/g, " ")}
            </p>

            <p className="font-semibold text-gray-900">
              ${safe(value)}
            </p>
          </div>
        ))}

        {/* TOTAL */}
        <div className="flex justify-between mt-4 pt-4 border-t">
          <p className="font-medium text-gray-800">Total Monthly Cost</p>
          <p className="font-bold text-lg">
            ${safe(total)}
          </p>
        </div>

      </div>
    </div>
  );
}
